export default function() {
  const opts = Array.prototype.pop.call(arguments);

  if (arguments.length < 1) {
    return opts.inverse(this);
  }

  if (arguments.length === 1) {
    return (arguments[0]) ? opts.fn(this) : opts.inverse(this);
  }

  let b = true;
  for (let i = 1; i < arguments.length; i++) {
    if (arguments[0] !== arguments[i]) {
      b = false;
      break;
    }
  }

  return b ? opts.fn(this) : opts.inverse(this);
}